import {
  RcsAgentBasicsStatusSchema,
  RcsAgentRegistrationStatusSchema,
  RcsBrandRegistrationStatusSchema,
} from "@redotech/redo-shopper-agent-settings-common/rcs-registration";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * What the admin RCS registration card renders: the live registration if one
 * exists, plus everything already known about the team so ops retypes nothing.
 */
export const getRcsRegistration = {
  name: "getRcsRegistration" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    /** Registration is keyed by account; a team without one cannot register. */
    hasAccount: z.boolean(),
    /** The agent id the send path uses, once an admin or adoption set it. */
    messagingAgentId: z.string().nullable(),
    registration: z
      .object({
        brandStatus: RcsBrandRegistrationStatusSchema,
        agentStatus: RcsAgentRegistrationStatusSchema,
        agentBasicsStatus: RcsAgentBasicsStatusSchema.nullable(),
        agentCampaignStatus: RcsAgentBasicsStatusSchema.nullable(),
        agentTestingStatus: RcsAgentBasicsStatusSchema.nullable(),
        telnyxBrandId: z.string().nullable(),
        telnyxAgentId: z.string().nullable(),
        messagingAgentId: z.string().nullable(),
        brandSubmittedAt: z.date().nullable(),
        agentSubmittedAt: z.date().nullable(),
        launchSubmittedAt: z.date().nullable(),
        lastFailureReason: z.string().nullable(),
        lastError: z.string().nullable(),
        lastSyncedAt: z.date().nullable(),
        adoptedAt: z.date().nullable(),
        submittedByEmail: z.string().nullable(),
      })
      .nullable(),
    /** Null where nothing is on file; the form falls back to its own default. */
    defaults: z.object({
      legalEntityName: z.string().nullable(),
      ein: z.string().nullable(),
      contactJobTitle: z.string().nullable(),
      brandDisplayName: z.string().nullable(),
      agentDisplayName: z.string().nullable(),
      supportEmail: z.string().nullable(),
      websiteUrl: z.string().nullable(),
      /** Brand kit artwork; neither slot is guaranteed to be the right size. */
      logoUrl: z.string().nullable(),
      heroUrl: z.string().nullable(),
      brandColor: z.string().nullable(),
    }),
    /**
     * Team fields the brand payload needs that no form here collects. A
     * non-empty list means submitting would throw before reaching Telnyx.
     */
    missingTeamFields: z.array(z.string()),
  }),
};
